<div class="grow overflow-y-auto">
    <valben-table
        [loading]="loading()"
        [columns]="cols"
        [values]="tableValues()"
        [refresh]="refresh"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        (lazyLoad)="loadPage($event)"
        (editEvent)="edit($event)"
        [addLabel]="'Dodaj lokaciju'"
        (addEvent)="add()"
    >
    </valben-table>
</div>
